import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Modal = ({
  head,
  text,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  zIndex
}: {
  head: string,
  text: string,
  confirmText: string | null,
  cancelText: string | null,
  onConfirm: any,
  onCancel: any,
  zIndex?: number
}) => {
  const { t } = useTranslation();
  return (
    <div
      className='modal'
      role='dialog'
      aria-modal='true'
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
      style={{ zIndex: zIndex || 2 }}
    >
      <div className='wrapper'>
        <div className='page-heading'>
          <h1 id='modal-title' role='heading'>{head}</h1>
        </div>
        <h4 id='modal-description' role='heading'>{text}</h4>
        <div className='buttons-holder center margin-t-50'>
          {onConfirm && confirmText && (
            <Button
              type='button'
              className='main-btn'
              variant='contained'
              size='large'
              onClick={onConfirm}
              aria-label={String(t('BUTTON.CONFIRM'))}
            >
              {confirmText}
            </Button>
          )}
          {onCancel && cancelText && (
            <Button
              type='button'
              className='secondary-btn'
              variant='contained'
              size='large'
              onClick={onCancel}
              aria-label={String(t('BUTTON.CANCEL'))}
            >
              {cancelText}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Modal
